import { groupBy } from 'lodash';
import moment from 'moment-timezone';

const namespaced = true;

const state = {
  items: [],
  itemTypes: [
    { value: 1, text: 'content.attendance_item.present' },
    { value: 2, text: 'content.attendance_item.late' },
    { value: 3, text: 'content.attendance_item.excuse_leave' },
    { value: 4, text: 'content.attendance_item.unexcuse_leave' },
    { value: 5, text: 'content.attendance_item.sick' }
  ]
};

const getters = {
  items: state => state.items,
  itemTypes: state => state.itemTypes
};

const mutations = {
  SET_ITEM: (state, payload) => (state.items = payload)
};

const actions = {
  // async fetchList({ commit, rootGetters }, payload) {
  //   try {
  //     const defaultPageable = rootGetters['table/defaultPageable'];
  //     const currentRole = rootGetters['Auth/currentRole'];
  //     const mapping = {
  //       sessionName: currentRole === 4 ? 'session_name' : 'sessionName'
  //     };
  //     const sortBy = payload?.sortBy?.[0] ? `${mapping[payload.sortBy?.[0]] ?? payload.sortBy?.[0]}|${payload.sortDesc?.[0] ? 'desc' : 'asc'}` : null;

  //     let params = {
  //       size: defaultPageable.limit,
  //       page: defaultPageable.currentPage - 1,
  //       search: defaultPageable.search,
  //       sortBy
  //     };

  //     let url;
  //     if (currentRole === 3) {
  //       const { courseId, classId, attendanceDate, attendanceTypeId } = payload;
  //       params = { ...params, attendanceDate, attendanceTypeId };
  //       const { studentId } = rootGetters['Auth/student'];
  //       url = `api/attendance/student/${studentId}/class/${classId}/course/${courseId}${attendanceDate || attendanceTypeId ? '/filter' : ''}`;
  //     } else if (currentRole == 5) {
  //       const { courseId, classId, attendanceDate, attendanceTypeId } = payload;
  //       params = { ...params, attendanceDate, attendanceTypeId };
  //       url = `api/attendance/class/${classId}/course/${courseId}${attendanceDate || attendanceTypeId ? '/filter' : ''}`;
  //     } else if (currentRole === 4) {
  //       const { classId, courseId } = payload;
  //       url = `api/attendance/classroom/${classId}/course/${courseId}`;
  //     }

  //     const {
  //       data: { data }
  //     } = await window.axios.get(url, { params });

  //     const { content, totalPages, totalElements } = data;
  //     commit('SET_ITEM', content);
  //     commit('table/SET_DEFAULT_TOTAL_PAGES', totalPages, { root: true });
  //     commit('table/SET_DEFAULT_TOTAL_ELEMENTS', totalElements, { root: true });
  //   } catch (err) {
  //     throw err;
  //   }
  // },

  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit, rootGetters }, payload) {
    const currentRole = rootGetters['Auth/currentRole'];

    const { courseId, classId, attendanceDate, attendanceTypeId, classSectionId } = payload;
    let params = {
      attendanceTypeId: payload.attendanceTypeId,
      attendanceDate: payload.attendanceDate,
      search: payload.searchData
    };

    let url;
    try {
      if (currentRole === 3) {
        const { studentId } = rootGetters['Auth/student'];
        if (!classSectionId) {
          url = `/api/attendance/student/${studentId}/class/${classId}/course/${courseId}${attendanceDate || attendanceTypeId ? '/' : ''}`;
        } else {
          url = `/api/attendance-parent/student/${studentId}/class-section/${classSectionId}${attendanceDate || attendanceTypeId ? '/' : ''}`;
        }

        const {
          data: { data }
        } = await window.axios.get(url, { params });
        return data;
      } else if (currentRole == 5) {
        if (!classSectionId) {
          url = `/api/attendance/class/${classId}/course/${courseId}${attendanceDate || attendanceTypeId ? '/' : ''}`;
        } else {
          url = `/api/attendance-student/class-section/${classSectionId}${attendanceDate || attendanceTypeId ? '/' : ''}`;
        }
        const {
          data: { data }
        } = await window.axios.get(url, { params });
        return data;
      } else if (currentRole == 4 || currentRole == 6) {
        if (!classSectionId) {
          url = `/api/attendance/classroom/${classId}/course/${courseId}?search=${payload.search}`;
        } else {
          url = `/api/attendance/class-section/${classSectionId}?search=${payload.search}`;
        }

        const {
          data: { data }
        } = await window.axios.get(url);

        return data;
      }
    } catch (err) {
      throw err;
    }
  },

  async fetchDetail(_context, id) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`api/attendance/${id}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },

  async fetchStudents(_context, { classId, courseId, classSectionId }) {
    try {
      let url;
      if (!classSectionId) {
        url = `api/attendance/classroom/${classId}/course/${courseId}/student-list`;
      } else {
        url = `api/attendance/class-section/${classSectionId}/student-list`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },

  save({ rootGetters }, payload) {
    const { classId, courseId, classSectionId } = payload;

    let url;
    if (!classSectionId) {
      url = `api/attendance/classroom/${classId}/course/${courseId}`;
    } else {
      url = `api/attendance/class-section/${classSectionId}`;
    }
    payload.lastUpdate = moment()
      .tz(payload.timezone)
      .format('YYYY-MM-DD HH:mm');
    return window.axios.post(`${url}`, {
      ...payload,
      schoolId: rootGetters['Auth/currentSchool']
    });
  },

  update({ rootGetters }, payload) {
    const { id } = payload;
    payload.lastUpdate = moment()
      .tz(payload.timezone)
      .format('YYYY-MM-DD HH:mm');
    return window.axios.put(`api/attendance/${id}`, {
      ...payload,
      schoolId: rootGetters['Auth/currentSchool']
    });
  },

  destroy(_context, payload) {
    let url;
    if (!payload.classSectionId) {
      url = `/api/attendance/${payload.id}/class/${payload.classId}/course/${payload.courseId}`;
    } else {
      url = `/api/attendance/${payload.id}/class-section/${payload.classSectionId}`;
    }
    return window.axios.delete(`${url}`);
  },

  // ---- Table Mode
  async fetchTableMode(_context, payload) {
    const { classId, courseId } = payload;
    try {
      let url;
      if (!payload.classSectionId) {
        url = `api/attendance/classroom/${classId}/course/${courseId}/table`;
      } else {
        url = `api/attendance/class-section/${payload.classSectionId}/table`;
      }
      const {
        data: { data }
      } = await window.axios.get(`${url}`);
      // console.info(data);
      data.students.forEach(element => {
        element.attendances.forEach(data => {
          var date = new Date(data.lastUpdated).toLocaleString('en-US', { timeZone: data.timezone, hour12: false });
          data.lastUpdated = date;
        });
      });
      return Promise.resolve(data);
    } catch (err) {
      throw err;
    }
  },

  async updateTableMode(_context, payload) {
    const { classId, courseId, data, classSectionId } = payload;
    try {
      let url;
      if (!classSectionId) {
        url = `api/attendance/classroom/${classId}/course/${courseId}/table`;
      } else {
        url = `api/attendance/class-section/${classSectionId}/table`;
      }
      const {
        data: { data: response }
      } = await window.axios.put(`${url}`, data);
      return Promise.resolve(response);
    } catch (err) {
      throw err;
    }
  },

  // eslint-disable-next-line no-unused-vars
  async export({ commit }, payload) {
    const { classId, courseId, classSectionId } = payload;
    let url;
    if (!classSectionId) {
      url = `api/attendance/classroom/${classId}/course/${courseId}/excel`;
    } else {
      url = `api/attendance/class-section/${classSectionId}/excel`;
    }
    return window.axios.get(`${url}`, { responseType: 'arraybuffer' });
  },

  // ---- Chart
  async fetchChart({ rootGetters }, payload) {
    try {
      let params = {
        size: 99999999,
        page: 0
      };

      const currentRole = rootGetters['Auth/currentRole'];
      let url;
      if (currentRole === 3) {
        const { courseId, classId, attendanceDate, attendanceTypeId, classSectionId } = payload;
        params = { ...params, attendanceDate, attendanceTypeId };
        const { studentId } = rootGetters['Auth/student'];
        if (!classSectionId) {
          url = `api/attendance/student/${studentId}/class/${classId}/course/${courseId}`;
        } else {
          url = `api/attendance-parent/student/${studentId}/class-section/${classSectionId}`;
        }
      } else if (currentRole == 5) {
        const { courseId, classId, attendanceDate, attendanceTypeId, classSectionId } = payload;
        params = { ...params, attendanceDate, attendanceTypeId };
        if (!classSectionId) {
          url = `api/attendance/class/${classId}/course/${courseId}`;
        } else {
          url = `api/attendance-student/class-section/${classSectionId}`;
        }
      }

      const {
        data: { data }
      } = await window.axios.get(url, { params });
      const group = groupBy(data, 'attendanceTypeId');
      return Promise.resolve({
        series: Object.keys(group).map(g => group[g].length),
        labels: Object.keys(group),
        length: data.length
      });
    } catch (err) {
      throw err;
    }
  }
};

export default { namespaced, state, getters, mutations, actions };
